export default __webpack_public_path__ + "static/logo30-59635a872f2299369d28c840b14aa80c.png";